import { createApp } from 'vue';
import InlineSvgPlugin from 'vue-inline-svg';
import VueScrollTo from 'vue-scrollto';

import App from '@/App.vue';
import Assets from '@/assets';
import Router from '@/router/index';
import Filters from '@/service/filter';
import API from '@/service/hub-api';
import Store from '@/store';
import Utils from '@/utils';

(async () => {
  await Utils.session.loadStoredSession();
  const app = createApp(App);

  app.component('inline-svg', InlineSvgPlugin);

  // TODO: change to native code
  app.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'linear',
    offset: 0,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
  });

  app.config.globalProperties.$assets = Assets;
  app.config.globalProperties.$utils = Utils;
  app.config.globalProperties.$filters = Filters;
  app.config.globalProperties.$api = API;

  app.use(Store);
  app.use(Router);
  app.mount('#hubFacilitatorPortal');
})();
